import { Module, MutationTree } from "vuex";
import { RootState } from "../../store.interface";
import { Transaction } from "@/shared/interfaces/transaction/Transaction.interface";
import { TransactionStoreState } from "@/shared/interfaces/transaction/TransactionStoreState.interface";

const state: TransactionStoreState = {
    initial: null,
    current: null,
};

const mutations: MutationTree<TransactionStoreState> = {
    initial: function(state, initialTransaction: Transaction) {
        state.initial = initialTransaction;
    },

    current: function(state, transaction: Transaction) {
        state.current = transaction;
    },

    paymentMethod: function(state, paymentMethod: string) {
        if (state.initial) {
            state.initial.paymentMethod = paymentMethod?.toUpperCase();
        }
    },
};

const transactions: Module<TransactionStoreState, RootState> = {
    namespaced: true,
    state: state,
    mutations: mutations,
};

export default transactions;
